import { render, staticRenderFns } from "./AtualizarUra.vue?vue&type=template&id=5372f1d5&"
import script from "./AtualizarUra.vue?vue&type=script&lang=js&"
export * from "./AtualizarUra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports